export const PRODUCTS = [
    {
        id: 1,
        name: 'Midnight Velvet Rose',
        collection: 'Signature Collection',
        price: 120,
        originalPrice: 145,
        tag: '15% OFF',
        rating: 5,
        color: 'purple',
        occasion: 'Romance',
        flowerType: 'Roses',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBhK5FjSif_NOWtpW-Qtp5U-kuUCzbM67XOQDwZ2Q8rA7xxuWkHahYZYQbbfDlvRu8e06J6J0BPWh2tmMVFsJBBfiNztzOzkrUI9M42_gV9DGEzwgpXh4M0r5Dy4LxMGxJpxFa8I0jtHdaZ8kQVIaggZ0xWcVDJ_Nq17uaP01pDky1SZpDCJtkBLO0J3WwQ2km2Q7mPau65wf-ss1BBEMx8pOFk19IOXMITBm2aHsSjc11BH16-quMjDm7gKSRJ-MES6TVcA264VmE'
    },
    {
        id: 2,
        name: 'Ethereal Lavender Mist',
        collection: 'Artisanal Choice',
        price: 85,
        tag: '',
        rating: 4,
        color: 'purple',
        occasion: 'Anniversary',
        flowerType: 'Orchids',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDNTCvai49vq932goWXMsUJy3nPSNpxYOzQghDgOxTt32fLih-PIv9sAG43zQ7VdyTGaD3BhFT07XpSfazGJEF5Kc0afPmfwgYTfAQCJAAPRrSX8EKea12sjMaU5tUXem2WgbMgtGF6ew7QrhzU7xB05b-hiPd7XHVpgrZ5NsdS2eg-SHXv7oWZYVrtoI5ZCuCguwSSJ_a3KEmseBRG2_faMDA0kPsIFAsTOq8-6rt3jHYkzHotYWxTSxXIpt_e0K1Q2eMiZCGuer8'
    },
    {
        id: 3,
        name: 'Amber Glow Peony',
        collection: 'Seasonal Limited',
        price: 115,
        tag: 'NEW',
        rating: 5,
        color: 'yellow',
        occasion: 'Birthday',
        flowerType: 'Peonies',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBXRd8VqJwIP_SQwgrAG63KTOcyU_zC7hhh-Ms9C9pOaLWRMAbnWbEmB6tFznxqn2XytTI6KTzKmje5iaqHbw3yz1EkLf-Pz2mfct3VXBziZoc7CMMh2CVqSm7lzSIlr0Kl3SqaQSbIrfA9ebDiXRCLgqCDdhxcUCg7fbgnZnckA6IcnpFkUszJVmYjnz3jDCw5aSEoh7-F5Cgr4a_7YtjfBIRmhi3grRq73zvuHnIctbXZZkfevlZ3c-qf7wqo4eWMXvIZ7e16y40'
    },
    {
        id: 4,
        name: 'Modern Bridal Luxe',
        collection: 'Wedding Exclusive',
        price: 210,
        tag: '',
        rating: 5,
        color: 'white',
        occasion: 'Wedding',
        flowerType: 'Lilies',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAZhzVrBToHt-FGHPwMgulIR9FD6kDnlTZPgiNH_lnKtyvP9g-SG6LsSYwu1a712AodPuy-l37REzEojFBkaxtzwJYlO476wLFpmBf-zZVbvdWGrwGK6zymj7G9ryZ4VK6fg5OxZwxw7ktB5GzCiaU0DJSq0-xMfG31VwOPP-zScq7h6h-FMWFwl7cW1WBSZD-dAVFP08gzNFIXgjOUhiK-iaAw1AhBwXUpnsUFbYp6kEQ2Qa9dd6CHN1T69rVfIBQF2-qwuiLwpWQ'
    },
    {
        id: 5,
        name: 'Midnight Lavender Dream',
        collection: 'Signature Collection',
        price: 125,
        tag: '15% OFF',
        rating: 5,
        color: 'purple',
        occasion: 'Romance',
        flowerType: 'Roses',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBhK5FjSif_NOWtpW-Qtp5U-kuUCzbM67XOQDwZ2Q8rA7xxuWkHahYZYQbbfDlvRu8e06J6J0BPWh2tmMVFsJBBfiNztzOzkrUI9M42_gV9DGEzwgpXh4M0r5Dy4LxMGxJpxFa8I0jtHdaZ8kQVIaggZ0xWcVDJ_Nq17uaP01pDky1SZpDCJtkBLO0J3WwQ2km2Q7mPau65wf-ss1BBEMx8pOFk19IOXMITBm2aHsSjc11BH16-quMjDm7gKSRJ-MES6TVcA264VmE'
    },
    {
        id: 6,
        name: 'Ethereal Blush Orchid',
        collection: 'Artisanal Choice',
        price: 95,
        tag: '',
        rating: 4,
        color: 'pink',
        occasion: 'Anniversary',
        flowerType: 'Orchids',
        inStock: false,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDNTCvai49vq932goWXMsUJy3nPSNpxYOzQghDgOxTt32fLih-PIv9sAG43zQ7VdyTGaD3BhFT07XpSfazGJEF5Kc0afPmfwgYTfAQCJAAPRrSX8EKea12sjMaU5tUXem2WgbMgtGF6ew7QrhzU7xB05b-hiPd7XHVpgrZ5NsdS2eg-SHXv7oWZYVrtoI5ZCuCguwSSJ_a3KEmseBRG2_faMDA0kPsIFAsTOq8-6rt3jHYkzHotYWxTSxXIpt_e0K1Q2eMiZCGuer8'
    },
    {
        id: 7,
        name: 'Luminous Calla Lily',
        collection: 'Seasonal Limited',
        price: 110,
        tag: 'NEW',
        rating: 5,
        color: 'white',
        occasion: 'Birthday',
        flowerType: 'Lilies',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBXRd8VqJwIP_SQwgrAG63KTOcyU_zC7hhh-Ms9C9pOaLWRMAbnWbEmB6tFznxqn2XytTI6KTzKmje5iaqHbw3yz1EkLf-Pz2mfct3VXBziZoc7CMMh2CVqSm7lzSIlr0Kl3SqaQSbIrfA9ebDiXRCLgqCDdhxcUCg7fbgnZnckA6IcnpFkUszJVmYjnz3jDCw5aSEoh7-F5Cgr4a_7YtjfBIRmhi3grRq73zvuHnIctbXZZkfevlZ3c-qf7wqo4eWMXvIZ7e16y40'
    },
    {
        id: 8,
        name: 'Royal Purple Orchid',
        collection: 'Wedding Exclusive',
        price: 245,
        tag: '',
        rating: 5,
        color: 'purple',
        occasion: 'Wedding',
        flowerType: 'Orchids',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAZhzVrBToHt-FGHPwMgulIR9FD6kDnlTZPgiNH_lnKtyvP9g-SG6LsSYwu1a712AodPuy-l37REzEojFBkaxtzwJYlO476wLFpmBf-zZVbvdWGrwGK6zymj7G9ryZ4VK6fg5OxZwxw7ktB5GzCiaU0DJSq0-xMfG31VwOPP-zScq7h6h-FMWFwl7cW1WBSZD-dAVFP08gzNFIXgjOUhiK-iaAw1AhBwXUpnsUFbYp6kEQ2Qa9dd6CHN1T69rVfIBQF2-qwuiLwpWQ'
    },
    {
        id: 9,
        name: 'Crimson Passion Bouquet',
        collection: 'Signature Collection',
        price: 135,
        originalPrice: 160,
        tag: 'NEW',
        rating: 5,
        color: 'red',
        occasion: 'Romance',
        flowerType: 'Roses',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBhK5FjSif_NOWtpW-Qtp5U-kuUCzbM67XOQDwZ2Q8rA7xxuWkHahYZYQbbfDlvRu8e06J6J0BPWh2tmMVFsJBBfiNztzOzkrUI9M42_gV9DGEzwgpXh4M0r5Dy4LxMGxJpxFa8I0jtHdaZ8kQVIaggZ0xWcVDJ_Nq17uaP01pDky1SZpDCJtkBLO0J3WwQ2km2Q7mPau65wf-ss1BBEMx8pOFk19IOXMITBm2aHsSjc11BH16-quMjDm7gKSRJ-MES6TVcA264VmE'
    },
    {
        id: 10,
        name: 'Pink Peony Whisper',
        collection: 'Seasonal Limited',
        price: 105,
        tag: '',
        rating: 4,
        color: 'pink',
        occasion: 'Birthday',
        flowerType: 'Peonies',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBXRd8VqJwIP_SQwgrAG63KTOcyU_zC7hhh-Ms9C9pOaLWRMAbnWbEmB6tFznxqn2XytTI6KTzKmje5iaqHbw3yz1EkLf-Pz2mfct3VXBziZoc7CMMh2CVqSm7lzSIlr0Kl3SqaQSbIrfA9ebDiXRCLgqCDdhxcUCg7fbgnZnckA6IcnpFkUszJVmYjnz3jDCw5aSEoh7-F5Cgr4a_7YtjfBIRmhi3grRq73zvuHnIctbXZZkfevlZ3c-qf7wqo4eWMXvIZ7e16y40'
    },
    {
        id: 11,
        name: 'Sun-kissed Tulip Glow',
        collection: 'Artisanal Choice',
        price: 75,
        tag: '10% OFF',
        rating: 5,
        color: 'yellow',
        occasion: 'Congratulations',
        flowerType: 'Lilies',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDNTCvai49vq932goWXMsUJy3nPSNpxYOzQghDgOxTt32fLih-PIv9sAG43zQ7VdyTGaD3BhFT07XpSfazGJEF5Kc0afPmfwgYTfAQCJAAPRrSX8EKea12sjMaU5tUXem2WgbMgtGF6ew7QrhzU7xB05b-hiPd7XHVpgrZ5NsdS2eg-SHXv7oWZYVrtoI5ZCuCguwSSJ_a3KEmseBRG2_faMDA0kPsIFAsTOq8-6rt3jHYkzHotYWxTSxXIpt_e0K1Q2eMiZCGuer8'
    },
    {
        id: 12,
        name: 'Ivory Bridal Harmony',
        collection: 'Wedding Exclusive',
        price: 195,
        tag: '',
        rating: 5,
        color: 'white',
        occasion: 'Wedding',
        flowerType: 'Lilies',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAZhzVrBToHt-FGHPwMgulIR9FD6kDnlTZPgiNH_lnKtyvP9g-SG6LsSYwu1a712AodPuy-l37REzEojFBkaxtzwJYlO476wLFpmBf-zZVbvdWGrwGK6zymj7G9ryZ4VK6fg5OxZwxw7ktB5GzCiaU0DJSq0-xMfG31VwOPP-zScq7h6h-FMWFwl7cW1WBSZD-dAVFP08gzNFIXgjOUhiK-iaAw1AhBwXUpnsUFbYp6kEQ2Qa9dd6CHN1T69rVfIBQF2-qwuiLwpWQ'
    },
    {
        id: 13,
        name: 'Scarlet Rose Devotion',
        collection: 'Signature Collection',
        price: 140,
        tag: 'NEW',
        rating: 5,
        color: 'red',
        occasion: 'Romance',
        flowerType: 'Roses',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBhK5FjSif_NOWtpW-Qtp5U-kuUCzbM67XOQDwZ2Q8rA7xxuWkHahYZYQbbfDlvRu8e06J6J0BPWh2tmMVFsJBBfiNztzOzkrUI9M42_gV9DGEzwgpXh4M0r5Dy4LxMGxJpxFa8I0jtHdaZ8kQVIaggZ0xWcVDJ_Nq17uaP01pDky1SZpDCJtkBLO0J3WwQ2km2Q7mPau65wf-ss1BBEMx8pOFk19IOXMITBm2aHsSjc11BH16-quMjDm7gKSRJ-MES6TVcA264VmE'
    },
    {
        id: 14,
        name: 'Magenta Orchid Grace',
        collection: 'Artisanal Choice',
        price: 130,
        tag: '',
        rating: 4,
        color: 'purple',
        occasion: 'Anniversary',
        flowerType: 'Orchids',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDNTCvai49vq932goWXMsUJy3nPSNpxYOzQghDgOxTt32fLih-PIv9sAG43zQ7VdyTGaD3BhFT07XpSfazGJEF5Kc0afPmfwgYTfAQCJAAPRrSX8EKea12sjMaU5tUXem2WgbMgtGF6ew7QrhzU7xB05b-hiPd7XHVpgrZ5NsdS2eg-SHXv7oWZYVrtoI5ZCuCguwSSJ_a3KEmseBRG2_faMDA0kPsIFAsTOq8-6rt3jHYkzHotYWxTSxXIpt_e0K1Q2eMiZCGuer8'
    },
    {
        id: 15,
        name: 'Blushing Peony Elegance',
        collection: 'Seasonal Limited',
        price: 125,
        tag: '',
        rating: 5,
        color: 'pink',
        occasion: 'Birthday',
        flowerType: 'Peonies',
        inStock: true,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBXRd8VqJwIP_SQwgrAG63KTOcyU_zC7hhh-Ms9C9pOaLWRMAbnWbEmB6tFznxqn2XytTI6KTzKmje5iaqHbw3yz1EkLf-Pz2mfct3VXBziZoc7CMMh2CVqSm7lzSIlr0Kl3SqaQSbIrfA9ebDiXRCLgqCDdhxcUCg7fbgnZnckA6IcnpFkUszJVmYjnz3jDCw5aSEoh7-F5Cgr4a_7YtjfBIRmhi3grRq73zvuHnIctbXZZkfevlZ3c-qf7wqo4eWMXvIZ7e16y40'
    },
    {
        id: 16,
        name: 'Pure White Tulip Harmony',
        collection: 'Wedding Exclusive',
        price: 90,
        tag: '',
        rating: 4,
        color: 'white',
        occasion: 'Wedding',
        flowerType: 'Lilies',
        inStock: false,
        image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAZhzVrBToHt-FGHPwMgulIR9FD6kDnlTZPgiNH_lnKtyvP9g-SG6LsSYwu1a712AodPuy-l37REzEojFBkaxtzwJYlO476wLFpmBf-zZVbvdWGrwGK6zymj7G9ryZ4VK6fg5OxZwxw7ktB5GzCiaU0DJSq0-xMfG31VwOPP-zScq7h6h-FMWFwl7cW1WBSZD-dAVFP08gzNFIXgjOUhiK-iaAw1AhBwXUpnsUFbYp6kEQ2Qa9dd6CHN1T69rVfIBQF2-qwuiLwpWQ'
    }
];
